<script>
import countries from './countries'
import Multiselect from 'vue-multiselect'
export default {
  name: 'country-select',
  components: {
    Multiselect
  },
  props: { value: { type: String } },
  data: vm => ({
    countries,
    selected: null
  }),
  watch: {
    value: {
      handler (v) {
        if (v) this.selected = this.countries.find(c => c.code === v)
      },
      immediate: true
    },
    selected: {
      handler (v) {
        this.$emit('input', v ? v.code : null)
      },
      immediate: true
    }
  }
}
</script>
<template>
  <multiselect
    :options="countries"
    :custom-label="({ code, name }) => `${name} (${code})`"
    track-by="name"
    v-model="selected"
    :placeholder="$attrs.placeholder || 'Select a Country'"
    :show-labels="false"
    :allow-empty="false"
    open-direction="above"
    v-bind="$attrs"
  />
</template>

<style lang="scss">
.multiselect__content-wrapper {
  overflow-x: hidden;
}
</style>
